import {Machine} from '@models/machine/machine';
import {User} from '@models/user/user';

export class MachineGroup {
  id: number = 0;
  name: string = '';
  parentName: string = '';
  parentId: number = -1;
  machines: Machine[] = [];
  subMachineGroups: number[] = [];
  machineGroups: MachineGroup[] = [];
  adminsGroup: boolean = false;
  users: User[] = [];
  externalId: string = '';
  parentExternalId: string = '';
  createdBy: string = '';
  creationTime: Date = new Date();
  normalizedName: string = '';
  disabled?: boolean;
}